/** */
export const READ_MANY_SENTRIES = 'read multiple sentries.';
export const READ_ONE_SENTRY = 'read one sentry.';

export const ADD_ONE_SENTRY_TO_STORE = 'add one sentry to store.';
export const ADD_SEARCH_RESULTS_TO_STORE = 'add sentry search results to store.';
export const ADD_MANY_SENTRIES_TO_STORE = 'add multiple sentries to store.';
export const LOAD_SENTRIES_TO_STORE = 'load up sentries to store.';
export const REM_ONE_SENTRY_FROM_STORE = 'remove a sentry from the store.';

/** */
export const readManySentries = (payload) => ({
  type: READ_MANY_SENTRIES,
  payload
});

export const readOneSentry = (payload) => ({
  type: READ_ONE_SENTRY,
  payload
});

export const addManySentriesToStore = (payload) => ({
  type: ADD_MANY_SENTRIES_TO_STORE,
  payload
});

export const addOneSentryToStore = (payload) => ({
  type: ADD_ONE_SENTRY_TO_STORE,
  payload
});

export const addSentrySearchResultsToStore = (payload) => ({
  type: ADD_SEARCH_RESULTS_TO_STORE,
  payload
});

export const loadSentriesToStore = (payload) => ({
  type: LOAD_SENTRIES_TO_STORE,
  payload
});

export const removeOneSentryFromStore = (payload) => ({
  type: REM_ONE_SENTRY_FROM_STORE,
  payload
});
